import React from 'react';

interface EarlyAccessProps {
  left?: string;
  right?: string;
  padding?:string;
  fontSize?:string;
}

const index: React.FC<EarlyAccessProps> = ({ left, right,fontSize,padding }) => {
  return (
    <div
      className="earlyAccessBtn"
      style={{
        backgroundColor: '#325E6A',
        color: 'white',
        padding: padding ? padding : '10px 15px 10px 15px',
        borderRadius: '23px',
        marginLeft: left ? left : '0px',
        marginRight: right ? right : '0px',
        minWidth: '80px',
        fontSize: fontSize ? fontSize : '',
        textAlign:'center'
      }}
    >
      EARLY ACCESS
    </div>
  );
};

export default index;
